// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"06951fd1e068abcd","4235":"17208dd180cdce52"}[chunkId] + ".css";
};